import React from "react"
import styled from "styled-components"
import { Flex, StyledLink } from "../../styles/base-styles"
import { WpPost } from "../../types/wordpress-types"
import { PostsSectionHeader } from "./posts-section-header"
import { PostLinks } from "./post-links"
import { getCategoryHeader } from "../../utils/constants"

interface Props {
  posts: WpPost[]
  categoryDatabaseId?: number
}

export const SameCategoryPosts: React.FC<Props> = ({
  posts,
  categoryDatabaseId,
}) => {
  const categoryLabelSettings = getCategoryHeader(categoryDatabaseId)
  return (
    <RelatedPostsFlex isColumn>
      <PostsSectionHeader
        title={`「${categoryLabelSettings?.name}」カテゴリの最新記事`}
      />
      <PostLinks posts={posts} isTable />
    </RelatedPostsFlex>
  )
}

const RelatedPostsFlex = styled(Flex)``
